import { DropDownButton, DropdownItem, Icon, IconName } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { ExportFormat } from '@mews-commander/data-access';
import { LedgerActivityReportUrlSearchValues } from '../schema';
import { useLedgerActivityReportExportMutation } from '../hooks/useLedgerActivityReportExportMutation';

interface LedgerActivityReportExportProps {
    filterValues: LedgerActivityReportUrlSearchValues;
}
export const LedgerActivityReportExport = ({ filterValues }: LedgerActivityReportExportProps) => {
    const {
        mutate: exportLedgerActivityReport,
        error,
        isPending,
    } = useLedgerActivityReportExportMutation({ filterValues });
    return (
        <DropDownButton
            icon={IconName.Exports}
            variant="tertiary"
            placement="bottom-end"
            overlayMinWidth={336}
            data-test-id="export-button"
        >
            <DropdownItem
                data-test-id="export-to-excel"
                label={lt('ExportToExcel')}
                leftDetail={<Icon value={IconName.Exports} size="small" />}
                onClick={() => exportLedgerActivityReport({ format: ExportFormat.Excel })}
                disabled={isPending || !!error}
            />
            <DropdownItem
                data-test-id="export-to-csv"
                label={lt('ExportToCsv')}
                leftDetail={<Icon value={IconName.Exports} size="small" />}
                onClick={() => exportLedgerActivityReport({ format: ExportFormat.Csv })}
                disabled={isPending || !!error}
            />
        </DropDownButton>
    );
};
